import React, { PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { Container, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

const HomeReorderRailContainer = (props: PropsWithChildren) => {
  const { match } = useResponsive();

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Container style={match([styles.containerXS, styles.containerSM])}>{props.children}</Container>
  );
};

/**
 * So that the reorder title is centered correctly with a space-between container.
 */
const HomeReorderRailSideWrapper = (props: PropsWithChildren) => {
  return <View style={styles.sideWrapper}>{props.children}</View>;
};

export const HomeReorderRail = {
  Container: HomeReorderRailContainer,
  SideWrapper: HomeReorderRailSideWrapper,
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  containerXS: {
    paddingHorizontal: 0,
    gap: theme.spacing['4'],
  },
  containerSM: {
    gap: theme.spacing['8'],
  },
  sideWrapper: {
    minWidth: 64,
  },
});
